"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconButton_1 = __importDefault(require("../../../../IconButton"));
var useStyles_1 = __importDefault(require("./useStyles"));
var CloseButton = function (props) {
    var disableButtonClose = props.disableButtonClose, onClose = props.onClose, showCloseButton = props.showCloseButton;
    var innerClasses = (0, useStyles_1.default)();
    if (!showCloseButton)
        return null;
    return (react_1.default.createElement(IconButton_1.default, { kind: "close", classes: { button: { root: innerClasses.button } }, disabled: disableButtonClose, onClick: onClose }));
};
exports.default = CloseButton;
